import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Cooladata } from '~/components/common/cooladata';
import { Layout } from '~/components/layout';
import { EmbedScriptListener } from '~/components/other';
import { ConfigurationProvider, ThemeProvider } from '~/components/providers';
import { GoogleAnalytics } from './components/common';
import { IS_DEV } from './constants';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/consistent-type-imports
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient;
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const queryClient = new QueryClient();
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigurationProvider>
        <ThemeProvider>
          <Layout />
          <EmbedScriptListener />
          {!IS_DEV && <Cooladata />}
          {import.meta.env.VITE_DEPLOY_TARGET === 'production' && <GoogleAnalytics />}
        </ThemeProvider>
      </ConfigurationProvider>
    </QueryClientProvider>
  );
}

export default App;
